import { render, staticRenderFns } from "./store_pc.vue?vue&type=template&id=22c15f7a&scoped=true&"
import script from "./store_pc.vue?vue&type=script&lang=js&"
export * from "./store_pc.vue?vue&type=script&lang=js&"
import style0 from "./store_pc.vue?vue&type=style&index=0&id=22c15f7a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22c15f7a",
  null
  
)

export default component.exports